import { createContext, useContext, useState } from 'react';

/**
 * Context for managing drag-and-drop state across dashboard columns
 * Allows tasks to be dragged from the Tasks column to timeblocks in the Schedule column
 */

const DragContext = createContext(null);

export function DragProvider({ children }) {
  const [draggedTask, setDraggedTask] = useState(null);

  return (
    <DragContext.Provider value={{ draggedTask, setDraggedTask }}>
      {children}
    </DragContext.Provider>
  );
}

export function useDrag() {
  const context = useContext(DragContext);
  if (!context) {
    throw new Error('useDrag must be used within a DragProvider');
  }
  return context;
}

export default DragContext;
